import { useEffect, useState } from 'react';
import { CheckHealt } from '../services/HealtCheck/HealtCheck';
import { useDispatch, useSelector } from 'react-redux';
import { setServerStatus } from '../redux/search.slice';

const ServerStatus = () => {
  const [status, setStatus] = useState(localStorage.getItem('serverStatus'));
  const isBackendWorking = useSelector(
    (state: any) => state.search.isBackendWorking
  );
  const dispatch = useDispatch();
  const [color, setColor] = useState<string>(
    status === 'true' && isBackendWorking === true
      ? 'orange'
      : status === 'true'
      ? 'green'
      : 'red'
  );

  const checkServerStatus = async (retryCount = 5) => {
    for (let attempt = 0; attempt < retryCount; attempt++) {
      try {
        const res = await CheckHealt();
        if (res.status === 200) {
          localStorage.setItem('serverStatus', 'true');
          setStatus('true');
          dispatch(setServerStatus(true));
          return;
        }
      } catch (error) {}
      await new Promise((resolve) => setTimeout(resolve, 3000));
    }

    localStorage.setItem('serverStatus', 'false');
    setStatus('false');
    dispatch(setServerStatus(false));
  };

  useEffect(() => {
    checkServerStatus();
  }, []);

  useEffect(() => {
    if (isBackendWorking && status === 'true') {
      setColor('orange');
    } else if (status === 'true') {
      setColor('green');
    } else {
      setColor('red');
    }
  }, [isBackendWorking, status]);

  return (
    <button
      onClick={async () => {
        await checkServerStatus();
      }}
      style={{
        width: '15px',
        height: '15px',
        borderRadius: '50%',
        backgroundColor: color,
      }}
    />
  );
};

export default ServerStatus;
